import { type WidgetSettingsDefinition } from "@repo/api";

export const getVisibleSettings = (
  settingsDefinition: WidgetSettingsDefinition[] | undefined,
  filters: string[] | undefined
): WidgetSettingsDefinition[] => {
  const defs = settingsDefinition ?? [];
  if (!filters?.length) {
    return defs;
  }
  const byId = new Map(defs.map((setting) => [setting.id, setting]));
  return filters
    .map((id) => byId.get(id))
    .filter(
      (setting): setting is WidgetSettingsDefinition => setting !== undefined
    );
};
